export const CLASSIC_SETTINGS = {
  maxItems: 50,
  maxItemsPerTrade: 10,
  minBet: 250,
} as const;
